import { gql } from "@apollo/client";

export const CREATE_TASK = gql`
  mutation CreateTaskMutation($input: CreateTaskInput!) {
    createTask(input: $input) {
      ok
      error
      id
    }
  }
`;

export const UPDATE_TASK = gql`
  mutation UpdateTaskMutation($id: Int!, $input: UpdateTaskInput!) {
    updateTask(id: $id, input: $input) {
      ok
      error
    }
  }
`;

export const REMOVE_TASK = gql`
  mutation RemoveTaskMutation($id: Int!) {
    removeTask(id: $id) {
      ok
      error
    }
  }
`;

export const TASK = gql`
  query TaskQuery($id: Int!) {
    task(id: $id) {
      ok
      error
      result {
        id
        title
        description
        status
        priority
        dueDate
        userId
        user {
          id
          firstname
          lastname
        }
      }
    }
  }
`;

export const TASKS = gql`
  query TasksQuery($where: TasksFiltersInput!) {
    tasks(where: $where) {
      ok
      error
      total
      results {
        id
        title
        description
        status
        priority
        dueDate
        userId
        user {
          id
          firstname
          lastname
        }
      }
    }
  }
`;
